import { observer, inject } from 'mobx-react';
import { makeStyles } from '@mui/styles';
import React, { FC, ReactElement, Fragment, useEffect } from 'react';
import Header from '../components/admin/Header';
import { Route, RouteComponentProps, Switch, withRouter } from 'react-router';
import IdleMonitor from 'components/common/IdleMonitor';
import StoreModel from 'models/Index';
import { Services } from 'helpers/constants/Services';
import { RoutePaths } from 'helpers/constants/RoutePaths';
import { MainPage, Registration } from 'containers/admin';

interface AdminProps extends RouteComponentProps {}

interface AdminPropsInjected extends AdminProps {
    Store: StoreModel;
}

const useStyles = makeStyles((theme) => {
    return {
        header: {
            display: 'flex',
            justifyContent: 'space-between',
            height: '170px',
        },
        headerLine: {
            height: '6px',
            background: '#e0e0e0',
        },

        body: {
            display: 'flex',
            flexDirection: 'column',
            height: 'calc(100vh - 176px)',
        },
    };
});

const AdminFlow: FC<AdminProps> = (props): ReactElement => {
    const { Store } = props as AdminPropsInjected;
    const { showIdleMonitor, configuration } = Store;

    const classes = useStyles();
    useEffect(() => {
        if (Store.isKioskRegistered) {
            Store.loadReceiptAttributes();
            Store.loadDeviceProfile();
        }

        // eslint-disable-next-line
    }, []);
    return (
        <Fragment>
            <div className={classes.header}>
                <Header />
            </div>
            <div className={classes.headerLine}></div>
            <div className={classes.body}>
                <Switch>
                    <Route
                        exact
                        path={RoutePaths.AdminHome}
                        component={MainPage}
                    />
                    <Route
                        path={RoutePaths.Registration}
                        component={Registration}
                    />
                </Switch>
            </div>
            {showIdleMonitor && (
                <IdleMonitor
                    inactivityTime={configuration.app.inactivityTime}
                    idleWaitTime={configuration.app.idleWaitTime}
                    store={Store}
                />
            )}
        </Fragment>
    );
};

export default inject(Services.STORE)(observer(withRouter(AdminFlow)));
